module.exports = __webpack_public_path__ + "img/map-turkey.1edf29d2.png";